type activeFunc = (page: string) => void;
type Get_ConnectedProps = {
    setActivePageId: activeFunc;
}

const Get_Connected = ({ setActivePageId }: Get_ConnectedProps) => {

    return (  
        <button 
        onClick={()=>{
            document.getElementById("contact-header-holder")?.scrollIntoView({ behavior: 'smooth' });
            setActivePageId("contact")
        }}
        className="contact-button py-3 px-4 huge-size rounded-3xl">Get Connected</button>
    );
}
 
export default Get_Connected;